// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { IconConstants, DxWidgetUtils, Utils, MessageBoxComponent } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

@Component({
    selector: 'app-dashboard-rename',
    templateUrl: './dashboard-rename.component.html',
    styleUrls: ['./dashboard-rename.component.scss']
})
export class DashboardRenameComponent implements OnInit {
    @ViewChild('renameWorkspacePopup', { static: false }) renameWorkspacePopup: DxPopupComponent;
    @ViewChild('messageBox', { static: false }) messageBox: MessageBoxComponent;

    @Input() workspaceName: string;

    @Output() onClose = new EventEmitter<string>();

    visible = false;

    iconCancel = IconConstants.CANCEL;
    iconSave = IconConstants.SAVE;

    ngOnInit() {
        this.visible = true;
    }

    onPopUpShown(): void {
        DxWidgetUtils.instantRepaint(this.renameWorkspacePopup);
    }

    onPopUpClose(): void {
        this.closeRenameWorkspacePopup(null);
    }

    onSave(): void {
        if (Utils.notNullAndDefined(this.workspaceName)) {
            this.closeRenameWorkspacePopup(this.workspaceName);
        } else {
            this.messageBox.showErrorMessage('Error', 'Workspace name is required');
        }
    }

    private closeRenameWorkspacePopup(name: string): void {
        this.visible = false;
        this.onClose.emit(name);
    }
}
